import { render, staticRenderFns } from "./MailVariableOverview.vue?vue&type=template&id=b5e3574a"
import script from "./MailVariableOverview.vue?vue&type=script&lang=js"
export * from "./MailVariableOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports